module.exports = __webpack_public_path__ + "static/media/instagram.543baf4b.svg";